module.exports = __webpack_public_path__ + "img/close.72eb9f7f.svg";